import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const description: SxStyle = {
  lineHeight: 1.5,
};

export const seeMore: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: 700,
};

export const dashed: SxStyle = {
  borderStyle: 'dashed',
};
